import React, { useState } from "react";
import { Link } from "react-router-dom";
import useSessionStore from "../stores/useSessionStore";

const SignIn = ({
  boxedLogo,
  boxedLogoLight,
  isLightTheme,
  signUpPath = "/advertisers/sign-up",
  forgotPasswordPath = "/advertisers/forgot-password",
  title = "Advertiser Sign-In",
}) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const handleLogin = useSessionStore((state) => state.handleLogin);
  const submitting = useSessionStore((state) => state.submitting);

  const validate = () => {
    const errs = {};
    if (!form.email.trim()) errs.email = "Email is required";
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email))
      errs.email = "Invalid email address";
    if (!form.password) errs.password = "Password is required";
    return errs;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: undefined });
    setServerError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError("");
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    const { success, error } = await handleLogin(form.email, form.password);
    if (!success) setServerError(error || "Invalid email or password");
  };

  return (
    <div className="sign-up-wrapper rainbow-section-gap">
      <div className="sign-up-box bg-flashlight">
        <div className="signup-box-top top-flashlight light-xl">
          <img
            className={`boxed-logo ${
              isLightTheme ? "boxed-logo-dark" : "boxed-logo-light"
            }`}
            src={isLightTheme ? boxedLogo : boxedLogoLight}
            width={180}
            alt="sign-up logo"
          />
        </div>
        <div className="separator-animated animated-true"></div>
        <div className="signup-box-bottom">
          <div className="signup-box-content">
            <h4 className="title">{title}</h4>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className="input-section mail-section">
                <div className="icon">
                  <i className="feather-mail"></i>
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  autoComplete="off"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>
              {errors.email && (
                <div className="signup-alert signup-alert-danger">
                  {errors.email}
                </div>
              )}
              <div className="input-section password-section">
                <div className="icon">
                  <i className="feather-lock"></i>
                </div>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  autoComplete="off"
                  value={form.password}
                  onChange={handleChange}
                />
              </div>
              {errors.password && (
                <div className="signup-alert signup-alert-danger">
                  {errors.password}
                </div>
              )}
              {serverError && (
                <div className="signup-alert signup-alert-danger">
                  {serverError}
                </div>
              )}
              <div className="forget-text">
                <Link className="btn-read-more" to={forgotPasswordPath}>
                  <span>Forgot password</span>
                </Link>
              </div>
              <button
                type="submit"
                className="btn-default"
                disabled={submitting}
              >
                {submitting ? "Signing In..." : "Sign In"}
              </button>
            </form>
          </div>
          <div className="signup-box-footer">
            <div className="bottom-text">
              Don&apos;t have an account?
              <Link className="btn-read-more ps-2" to={signUpPath}>
                <span>Sign Up</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
